import { NaverMemberState } from 'common/ducks/naverMember'
import { axios } from 'common/utils'
import { getHeaders } from 'common/utils/ajax/axios'

export const fetchNaveMember = async (headers?: any): Promise<NaverMemberState> => {
  const result = await axios
    .get<NaverMemberState>(`/v1/members`, {
      ...getHeaders(headers),
    })
    .catch(error => {
      return null
    })
  return result && result.data
}
